import React, {useState} from 'react'
import {Card} from 'react-bootstrap';
import {useQuery} from "@apollo/client";
import {connect} from "react-redux";

import {signUpQueries} from "../../../../../store/actions/AuthActions/SignUpGraphQL";
import '../../../../../assets/sass/pages/auth/sign-up.scss';

import coach from "../../../../../assets/svg/auth/role/coach.svg";
import clubManager from "../../../../../assets/svg/auth/role/club-manager.svg";
import playerAgent from "../../../../../assets/svg/auth/role/player-agent.svg";
import player from "../../../../../assets/svg/auth/role/player.svg";
import scout from "../../../../../assets/svg/auth/role/scout.svg";
import SelectProfessionStep from "./SelectProfessionStep";
import SelectClubAgencyStep from "./SelectClubAgencyStep";
import SubmitFormStep from "./SubmitFormStep";
import {userSignUp} from "../../../../../store/actions/AuthActions/SignUpActions";


const SignUpForm = (props) => {

    /**
     * Constants values.
     * @type {string}
     */
    const signUpText = 'Sign Up';


    const professionOptions = [
        {label: 'Coach', value: 'coach', svg: coach},
        {label: 'Club Manager', value: 'clubManager', svg: clubManager},
        {label: 'Player', value: 'player', svg: player},
        {label: 'Player Agent', value: 'playerAgent', svg: playerAgent},
        {label: 'Scout', value: 'scout', svg: scout},
    ];


    /**
     * Current step of registration.
     */
    const [step, setStep] = useState(1);
    const [profession, setProfession] = useState(professionOptions[0]);
    const [clubAgency, setClubAgency] = useState(undefined);

    /**
     * Handle select profession.
     * @param option {object} The selected option.
     */
    const handleProfessionSelect = (option) => setProfession(option);

    /**
     * Handle select Club or Agency.
     * @param option
     */
    const handleClubAgencySelect = (option) => setClubAgency(option);

    /**
     * When user click on back button.
     */
    const handleBackClick = () => setStep(Math.max(step - 1, 1));

    /**
     * When user click on next button.
     */
    const handleNextClick = () => setStep(Math.min(step + 1, 3));


    /**
     * When user click on next button.
     */
    const {signUp} = props;
    const {isSubmitting, errors} = props;

    const handleSubmit = (user, setErrors) => signUp(user).catch(error => setErrors(error.message));

    const {loading: clubAgencyLoading, error: clubAgencyError, data: clubAgencyData} = useQuery(signUpQueries.clubAgency);
    return (
        <Card className="sign-up">
            <h1 className="text-center">{signUpText} </h1>
            {step === 1 && <SelectProfessionStep
                options={professionOptions}
                value={profession?.value}
                onSelect={handleProfessionSelect}
                onNextClick={handleNextClick}/>}

            {step === 2 && <SelectClubAgencyStep
                value={clubAgency?.value}
                professionValue={profession?.value}
                loading={clubAgencyLoading}
                error={clubAgencyError}
                data={clubAgencyData}
                onSelect={handleClubAgencySelect}
                onBackClick={handleBackClick}
                onNextClick={handleNextClick}/>}

            {step === 3 && <SubmitFormStep
                profession={profession}
                clubAgency={clubAgency}
                isSubmitting={isSubmitting}
                errors={errors}
                onBackClick={handleBackClick}
                onSubmit={handleSubmit}
            />
            }
        </Card>
    );


};

const mapStateToProps = state => {
    return {
        /**
         *
         */
        signedUp: state.auth.signUp.success,

        /**
         * Signing up
         */
        isSubmitting: state.auth.signUp.loading,


        /**
         * Signing up errors
         */
        errors: state.auth.errors.signUp,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        /**
         * Signing up using user data.
         * @param user {object} The entered information of user.
         * @returns {Promise} The axsios promise.
         */

        signUp: (user) => dispatch(userSignUp(user))
            .then(() => window.location.href = '/dashboard'),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);
